module.exports = [
	{
		"name": "All funds"
	},
	{
		"name": "1290 Funds"
	},
	{
		"name": "13D Activist Fund"
	},
	{
		"name": "1919 Funds"
	},
	{
		"name": "3fourteensmi"
	},
	{
		"name": "AAM"
	},
	{
		"name": "AAMA"
	},
	{
		"name": "ACR Alpine Capital Research"
	},
	{
		"name": "ACV ETFs"
	},
	{
		"name": "ALPHA BLUE CAPITAL"
	},
	{
		"name": "ALPS"
	},
	{
		"name": "AMF"
	},
	{
		"name": "AMG Funds"
	},
	{
		"name": "AOT Invest LLC"
	},
	{
		"name": "APTUS ETFs"
	},
	{
		"name": "AQR Funds"
	},
	{
		"name": "ARGA"
	},
	{
		"name": "ARK ETF Trust"
	},
	{
		"name": "AXS"
	},
	{
		"name": "Aberdeen"
	},
	{
		"name": "Absolute Investment Advisers"
	},
	{
		"name": "Acadian Funds"
	},
	{
		"name": "Acquirers Funds"
	},
	{
		"name": "Acruence"
	},
	{
		"name": "Active Passive Funds"
	},
	{
		"name": "Acuitas Investments"
	},
	{
		"name": "Adam Asset Funds"
	},
	{
		"name": "Adaptive ETF"
	},
	{
		"name": "Adasina"
	},
	{
		"name": "Adirondack Funds"
	},
	{
		"name": "Adler"
	},
	{
		"name": "AdvisorShares"
	},
	{
		"name": "Advisors Capital"
	},
	{
		"name": "Advisors Preferred"
	},
	{
		"name": "Aegis"
	},
	{
		"name": "Affinity Investment Advisors, LLC"
	},
	{
		"name": "Akre"
	},
	{
		"name": "Al Frank"
	},
	{
		"name": "Alger"
	},
	{
		"name": "AllianceBernstein"
	},
	{
		"name": "Allied Asset"
	},
	{
		"name": "Allspring Global Investments"
	},
	{
		"name": "Alpha Architect"
	},
	{
		"name": "AlphaCentric Funds"
	},
	{
		"name": "Alta Capital"
	},
	{
		"name": "Altair"
	},
	{
		"name": "Altegris"
	},
	{
		"name": "Altrius Capital Management,Inc."
	},
	{
		"name": "Amana"
	},
	{
		"name": "AmericaFirst Funds"
	},
	{
		"name": "American Beacon"
	},
	{
		"name": "American Century Investments"
	},
	{
		"name": "American Funds/Capital Group"
	},
	{
		"name": "American Growth"
	},
	{
		"name": "Amplify ETFs"
	},
	{
		"name": "Amundi US"
	},
	{
		"name": "Ancora"
	},
	{
		"name": "Applied Finance"
	},
	{
		"name": "Archer"
	},
	{
		"name": "Argent"
	},
	{
		"name": "Ariel Investments"
	},
	{
		"name": "Aristotle Funds"
	},
	{
		"name": "Armada ETF"
	},
	{
		"name": "Artisan Partners Funds"
	},
	{
		"name": "Ashmore"
	},
	{
		"name": "Aspiration Funds"
	},
	{
		"name": "Astoria Capital Partners L P"
	},
	{
		"name": "Auer"
	},
	{
		"name": "Auxier Funds"
	},
	{
		"name": "Avantis Investors"
	},
	{
		"name": "Ave Maria Mutual Funds"
	},
	{
		"name": "Aztlan ETFs"
	},
	{
		"name": "Azzad Fund"
	},
	{
		"name": "BBH"
	},
	{
		"name": "BFS"
	},
	{
		"name": "BMO Capital Markets"
	},
	{
		"name": "BNY Mellon"
	},
	{
		"name": "BTS"
	},
	{
		"name": "Bahl & Gaynor Inc."
	},
	{
		"name": "Bahl & Gaynor Investment Counsel"
	},
	{
		"name": "Baillie Gifford Funds"
	},
	{
		"name": "Bain Capital Public Equity LP"
	},
	{
		"name": "Baird"
	},
	{
		"name": "Ballast Asset Management"
	},
	{
		"name": "Bancreek Capital Advisors, LLC"
	},
	{
		"name": "Baron Capital Group, Inc."
	},
	{
		"name": "Baywood"
	},
	{
		"name": "Beck, Mack & Oliver"
	},
	{
		"name": "Becker"
	},
	{
		"name": "BeeHive"
	},
	{
		"name": "Berkshire"
	},
	{
		"name": "Beyond Advisors IC"
	},
	{
		"name": "Biondo Investment Advisor"
	},
	{
		"name": "Bitwise Investments"
	},
	{
		"name": "BlackRock/iShares"
	},
	{
		"name": "Blue Chip Investor Fund"
	},
	{
		"name": "Blue Current Funds"
	},
	{
		"name": "Blueprint Fund Management"
	},
	{
		"name": "Boston Common"
	},
	{
		"name": "Boston Partners"
	},
	{
		"name": "Boston Trust Walden Funds"
	},
	{
		"name": "Boyar Value Fund"
	},
	{
		"name": "Brandes"
	},
	{
		"name": "Brendan Wood TopGun Partnerships Inc."
	},
	{
		"name": "Bretton Fund"
	},
	{
		"name": "Bridge Builder"
	},
	{
		"name": "Bridges"
	},
	{
		"name": "Bridgeway"
	},
	{
		"name": "Bright Rock"
	},
	{
		"name": "Brookfield Investment Funds"
	},
	{
		"name": "Brookstone Asset Management"
	},
	{
		"name": "Brown Advisory Funds"
	},
	{
		"name": "Brown Capital Management"
	},
	{
		"name": "Bruce"
	},
	{
		"name": "Buffalo"
	},
	{
		"name": "Bullfinch"
	},
	{
		"name": "Bushido"
	},
	{
		"name": "CAMBRIA ETF TRUST"
	},
	{
		"name": "CIBC Private Wealth Management"
	},
	{
		"name": "CRM"
	},
	{
		"name": "CULTIVAR ETF"
	},
	{
		"name": "Calamos"
	},
	{
		"name": "Calvert ETFs"
	},
	{
		"name": "Calvert Research and Management"
	},
	{
		"name": "Cambiar Funds"
	},
	{
		"name": "Cantor"
	},
	{
		"name": "Capital Advisors"
	},
	{
		"name": "Capital Research and Management Company"
	},
	{
		"name": "Carbon Collective Funds"
	},
	{
		"name": "Carillon Family of Funds"
	},
	{
		"name": "Castle Investment Management"
	},
	{
		"name": "CastleArk Management LLC"
	},
	{
		"name": "Catalyst Mutual Funds"
	},
	{
		"name": "Catholic Responsible Investments Funds"
	},
	{
		"name": "Causeway"
	},
	{
		"name": "Cavanal Hill funds"
	},
	{
		"name": "Champlain Funds"
	},
	{
		"name": "Channing Capital"
	},
	{
		"name": "Chase"
	},
	{
		"name": "Chesapeake"
	},
	{
		"name": "Chevy Chase Trust Company"
	},
	{
		"name": "City National Rochdale"
	},
	{
		"name": "Clark Fork Trust"
	},
	{
		"name": "Clarkston Funds"
	},
	{
		"name": "Clifford Capital"
	},
	{
		"name": "Clipper Fund"
	},
	{
		"name": "Clockwise Capital Innovation ETF"
	},
	{
		"name": "Clough Capital Partners L.P."
	},
	{
		"name": "Cohen & Steers"
	},
	{
		"name": "Coho"
	},
	{
		"name": "Columbia Threadneedle"
	},
	{
		"name": "Column Funds"
	},
	{
		"name": "Commerce"
	},
	{
		"name": "Commonwealth Intl Series Tr"
	},
	{
		"name": "Concorde"
	},
	{
		"name": "Conductor"
	},
	{
		"name": "Conestoga Capital Advisors"
	},
	{
		"name": "Congress"
	},
	{
		"name": "Cook & Bynum"
	},
	{
		"name": "Copeland Funds"
	},
	{
		"name": "Copley"
	},
	{
		"name": "CornerCap"
	},
	{
		"name": "Counterpoint Funds"
	},
	{
		"name": "Crawford"
	},
	{
		"name": "Cromwell"
	},
	{
		"name": "CrossingBridge"
	},
	{
		"name": "Crossmark Steward Funds"
	},
	{
		"name": "Cullen Funds Trust"
	},
	{
		"name": "Curran Investment Partners"
	},
	{
		"name": "Cutler"
	},
	{
		"name": "DEMZ"
	},
	{
		"name": "DF Dent Funds"
	},
	{
		"name": "DGI"
	},
	{
		"name": "DWS"
	},
	{
		"name": "Dana Investment"
	},
	{
		"name": "Davenport"
	},
	{
		"name": "Davidson Mutual Funds"
	},
	{
		"name": "Davis"
	},
	{
		"name": "Dean Fund"
	},
	{
		"name": "Dearborn Partners"
	},
	{
		"name": "Defiance ETFs"
	},
	{
		"name": "Delaware Funds by Macquarie"
	},
	{
		"name": "Democracy Investments"
	},
	{
		"name": "Destinations Funds"
	},
	{
		"name": "Dhandho Funds"
	},
	{
		"name": "Diamond Hill Funds"
	},
	{
		"name": "Dimensional Fund Advisors"
	},
	{
		"name": "Direxion Funds"
	},
	{
		"name": "Distillate Capital Partners"
	},
	{
		"name": "Dodge & Cox"
	},
	{
		"name": "Domini"
	},
	{
		"name": "Donoghue Forlines LLC"
	},
	{
		"name": "DoubleLine"
	},
	{
		"name": "Driehaus"
	},
	{
		"name": "Dunham Funds"
	},
	{
		"name": "EIP Funds"
	},
	{
		"name": "EMQQ"
	},
	{
		"name": "Eagle Capital Management, LLC"
	},
	{
		"name": "Eagle MLP"
	},
	{
		"name": "Easterly Funds"
	},
	{
		"name": "Eaton Vance"
	},
	{
		"name": "Edgar Lomax"
	},
	{
		"name": "Edgewood"
	},
	{
		"name": "Emerald"
	},
	{
		"name": "Emerald Mutual Fund Advisers Trust"
	},
	{
		"name": "Empiric Funds"
	},
	{
		"name": "Empower Funds"
	},
	{
		"name": "Empowered Funds, LLC"
	},
	{
		"name": "EntrepreneurShares"
	},
	{
		"name": "Equity Investment Corp"
	},
	{
		"name": "Euclidean Technologies Management, LLC"
	},
	{
		"name": "Euro Pacific Asset Management"
	},
	{
		"name": "Eventide Funds"
	},
	{
		"name": "Evolutionary Tree"
	},
	{
		"name": "Exchange Traded Concepts"
	},
	{
		"name": "Exponential ETFs"
	},
	{
		"name": "F/m investments, LLC"
	},
	{
		"name": "FAM"
	},
	{
		"name": "FCF Funds"
	},
	{
		"name": "FMI Funds"
	},
	{
		"name": "FMQQ"
	},
	{
		"name": "FPA"
	},
	{
		"name": "Fairholme"
	},
	{
		"name": "Faith Investor"
	},
	{
		"name": "Federated"
	},
	{
		"name": "Fidelity Investments"
	},
	{
		"name": "First American"
	},
	{
		"name": "First Eagle"
	},
	{
		"name": "First Manhattan Co."
	},
	{
		"name": "First Sentier"
	},
	{
		"name": "First Sentier Investors"
	},
	{
		"name": "First Trust"
	},
	{
		"name": "Firsthand Funds"
	},
	{
		"name": "Fisher Investments"
	},
	{
		"name": "Flexshares Trust"
	},
	{
		"name": "Forester"
	},
	{
		"name": "Formidable Funds"
	},
	{
		"name": "Fort Pitt Capital Funds"
	},
	{
		"name": "Foundry"
	},
	{
		"name": "Frank Funds"
	},
	{
		"name": "Franklin Templeton Investments"
	},
	{
		"name": "Freedom Day Solutions, LLC"
	},
	{
		"name": "Frontier Funds"
	},
	{
		"name": "Frost Funds"
	},
	{
		"name": "FullerThaler"
	},
	{
		"name": "Fundstrat"
	},
	{
		"name": "GMO"
	},
	{
		"name": "GQG Partners Inc"
	},
	{
		"name": "Gabelli"
	},
	{
		"name": "Geneva"
	},
	{
		"name": "Genter Capital Management"
	},
	{
		"name": "Genter funds"
	},
	{
		"name": "Glenmede"
	},
	{
		"name": "Global X Funds"
	},
	{
		"name": "Goehring & Rozencwajg"
	},
	{
		"name": "Goldman Sachs"
	},
	{
		"name": "Golub"
	},
	{
		"name": "GoodHaven"
	},
	{
		"name": "Gotham"
	},
	{
		"name": "Grandeur Peak Funds"
	},
	{
		"name": "Grandeur peak global"
	},
	{
		"name": "Graniteshares"
	},
	{
		"name": "Green Century"
	},
	{
		"name": "Grizzle ETF"
	},
	{
		"name": "Guardian Capital LP"
	},
	{
		"name": "GuideMark"
	},
	{
		"name": "GuidePath"
	},
	{
		"name": "GuideStone Funds"
	},
	{
		"name": "Guinness Atkinson"
	},
	{
		"name": "GuruFocusETF"
	},
	{
		"name": "HVIA Equity Fund"
	},
	{
		"name": "Hamlin Funds"
	},
	{
		"name": "Harbor"
	},
	{
		"name": "Harding Loevner"
	},
	{
		"name": "Hartford Mutual Funds"
	},
	{
		"name": "Haverford"
	},
	{
		"name": "Heartland"
	},
	{
		"name": "Hennessy"
	},
	{
		"name": "Hillman Capital Management"
	},
	{
		"name": "Hilton Capital Management, LLC"
	},
	{
		"name": "Hodges"
	},
	{
		"name": "Homestead"
	},
	{
		"name": "Honeytree"
	},
	{
		"name": "Hood River Capital Management"
	},
	{
		"name": "Horizon Investments"
	},
	{
		"name": "Horizon Kinetics"
	},
	{
		"name": "Hotchkis & Wiley"
	},
	{
		"name": "Hoya Capital Real Estate"
	},
	{
		"name": "Huber Funds"
	},
	{
		"name": "Humankind"
	},
	{
		"name": "Hunter Perkins Capital Management, LLC"
	},
	{
		"name": "Hypatia Capital Group"
	},
	{
		"name": "ICON Funds"
	},
	{
		"name": "IMS"
	},
	{
		"name": "IRET ETF"
	},
	{
		"name": "Impact Shares"
	},
	{
		"name": "Impax Asset Management"
	},
	{
		"name": "Independent Franchise Partners"
	},
	{
		"name": "Indexperts"
	},
	{
		"name": "InfraCap"
	},
	{
		"name": "Innealta Capital"
	},
	{
		"name": "Innovator ETFs"
	},
	{
		"name": "Inspire"
	},
	{
		"name": "Intech"
	},
	{
		"name": "IntegrityVikingFunds"
	},
	{
		"name": "Intelligent Funds"
	},
	{
		"name": "Intrepid Funds"
	},
	{
		"name": "Invenomic"
	},
	{
		"name": "Invesco"
	},
	{
		"name": "Investment House Funds"
	},
	{
		"name": "Issachar Fund"
	},
	{
		"name": "JAG Capital Management"
	},
	{
		"name": "JLens"
	},
	{
		"name": "JOHCM Funds"
	},
	{
		"name": "JPMorgan"
	},
	{
		"name": "Jackson National"
	},
	{
		"name": "Jackson Square"
	},
	{
		"name": "Jacob"
	},
	{
		"name": "James Advantage"
	},
	{
		"name": "Janus Henderson"
	},
	{
		"name": "Jensen"
	},
	{
		"name": "John Hancock"
	},
	{
		"name": "Johnson Mutual Funds"
	},
	{
		"name": "KBI"
	},
	{
		"name": "KKM Financial LLC"
	},
	{
		"name": "Keeley"
	},
	{
		"name": "Kempner"
	},
	{
		"name": "Kennedy Capital Management"
	},
	{
		"name": "Kinetics"
	},
	{
		"name": "Kingsbarn Capital"
	},
	{
		"name": "Kirr Marbach Partners"
	},
	{
		"name": "Knights of Columbus Asset Advisors"
	},
	{
		"name": "Knowledge Leaders Capital"
	},
	{
		"name": "Kopernik"
	},
	{
		"name": "KraneShares"
	},
	{
		"name": "Kurv Investment Management Inc."
	},
	{
		"name": "LKCM"
	},
	{
		"name": "LSV Fund"
	},
	{
		"name": "Laffer Tengler Investments, Inc."
	},
	{
		"name": "Langar Funds"
	},
	{
		"name": "Lawson Kroeker"
	},
	{
		"name": "Lazard"
	},
	{
		"name": "Leavell"
	},
	{
		"name": "Leuthold"
	},
	{
		"name": "Liberty Street"
	},
	{
		"name": "Life + Liberty Investments, LLC"
	},
	{
		"name": "Lisanti SmallCap"
	},
	{
		"name": "LoCorr Funds"
	},
	{
		"name": "Logan Capital"
	},
	{
		"name": "Long Pond Capital, LP"
	},
	{
		"name": "Longleaf Partners"
	},
	{
		"name": "Longview Funds"
	},
	{
		"name": "Loomis Sayles Funds"
	},
	{
		"name": "Lord Abbett"
	},
	{
		"name": "Lyrical"
	},
	{
		"name": "M3Sixty"
	},
	{
		"name": "MFS"
	},
	{
		"name": "MP 63"
	},
	{
		"name": "MSA Power Funds LLC"
	},
	{
		"name": "Macquarie"
	},
	{
		"name": "Madison Asset Management, LLC"
	},
	{
		"name": "Madison Funds"
	},
	{
		"name": "Main Management ETFs"
	},
	{
		"name": "MainGate Trust"
	},
	{
		"name": "Mairs & Power"
	},
	{
		"name": "Manning & Napier"
	},
	{
		"name": "Manor Investment Funds"
	},
	{
		"name": "MarketDesk"
	},
	{
		"name": "Marmont Funds"
	},
	{
		"name": "Marshfield"
	},
	{
		"name": "Marsico Investment Fund"
	},
	{
		"name": "MassMutual"
	},
	{
		"name": "Matrix Advisors Funds Trust"
	},
	{
		"name": "Matrix Asset Advisors Inc"
	},
	{
		"name": "Matthew 25"
	},
	{
		"name": "Matthews Asia Funds"
	},
	{
		"name": "Meeder Funds"
	},
	{
		"name": "Meehan Focus"
	},
	{
		"name": "Mercer Funds"
	},
	{
		"name": "Meridian"
	},
	{
		"name": "Mesirow"
	},
	{
		"name": "Midas"
	},
	{
		"name": "Miller Value Funds"
	},
	{
		"name": "Modern Capital"
	},
	{
		"name": "Moerus Funds"
	},
	{
		"name": "Mohrfunds"
	},
	{
		"name": "Monarch Funds"
	},
	{
		"name": "Moncapfund"
	},
	{
		"name": "Mondrian"
	},
	{
		"name": "Monetta"
	},
	{
		"name": "Monteagle Funds"
	},
	{
		"name": "Morgan Dempsey"
	},
	{
		"name": "Morgan Stanley"
	},
	{
		"name": "Morningstar"
	},
	{
		"name": "Motley Fool"
	},
	{
		"name": "Muhlenkamp"
	},
	{
		"name": "Mundoval Funds"
	},
	{
		"name": "Mutual of America"
	},
	{
		"name": "NEXPOINT FUNDS I"
	},
	{
		"name": "National security index"
	},
	{
		"name": "Nationwide"
	},
	{
		"name": "Natixis Funds"
	},
	{
		"name": "Needham"
	},
	{
		"name": "Neiman Funds"
	},
	{
		"name": "Neos Funds"
	},
	{
		"name": "Neuberger Berman"
	},
	{
		"name": "New Age Alpha Advisors LLC"
	},
	{
		"name": "New Alternatives"
	},
	{
		"name": "New Covenant"
	},
	{
		"name": "New York Life Investment Management LLC"
	},
	{
		"name": "Nia Impact Capital"
	},
	{
		"name": "Nicholas"
	},
	{
		"name": "Nicholas Investment Partners"
	},
	{
		"name": "Nightview"
	},
	{
		"name": "North Country Funds"
	},
	{
		"name": "North Square"
	},
	{
		"name": "North Star"
	},
	{
		"name": "NorthQuest Fund"
	},
	{
		"name": "Northern Funds"
	},
	{
		"name": "Nuance Investments"
	},
	{
		"name": "O'Shaughnessy Mutual Funds"
	},
	{
		"name": "OCM"
	},
	{
		"name": "ONEFUND Trust"
	},
	{
		"name": "Oak Associates"
	},
	{
		"name": "Oakmark"
	},
	{
		"name": "Oaktree Funds"
	},
	{
		"name": "Oberweis"
	},
	{
		"name": "Oelschlager Investments"
	},
	{
		"name": "Old Westbury"
	},
	{
		"name": "Olstein"
	},
	{
		"name": "OneAscent Investment ETF"
	},
	{
		"name": "Osterweis"
	},
	{
		"name": "Otter Creek"
	},
	{
		"name": "PGIM Investments"
	},
	{
		"name": "PIMCO"
	},
	{
		"name": "PLUS ETF"
	},
	{
		"name": "PRIMECAP Odyssey Funds"
	},
	{
		"name": "Pacer"
	},
	{
		"name": "Pacific Capital Partners Limited"
	},
	{
		"name": "Papp"
	},
	{
		"name": "Paradigm Funds"
	},
	{
		"name": "Paralel Advisors LLC"
	},
	{
		"name": "Parnassus"
	},
	{
		"name": "Patient Capital Management"
	},
	{
		"name": "Paydenfunds"
	},
	{
		"name": "Payson Funds"
	},
	{
		"name": "Pear Tree Funds"
	},
	{
		"name": "Penn Capital Management"
	},
	{
		"name": "Perkins"
	},
	{
		"name": "Permanent Portfolio Family of Funds"
	},
	{
		"name": "Perpetual Funds"
	},
	{
		"name": "Perritt"
	},
	{
		"name": "Pinnacle"
	},
	{
		"name": "Plumb Funds"
	},
	{
		"name": "Point Bridge Capital"
	},
	{
		"name": "Polar Capital LLP"
	},
	{
		"name": "Polaris Funds"
	},
	{
		"name": "Polen Capital"
	},
	{
		"name": "Poplar Forest Capital"
	},
	{
		"name": "Port Street Investments"
	},
	{
		"name": "Praxis Investment Management, Inc."
	},
	{
		"name": "Principal Funds"
	},
	{
		"name": "Private Capital Management"
	},
	{
		"name": "ProFunds"
	},
	{
		"name": "ProShares"
	},
	{
		"name": "Procure ETF Trust II"
	},
	{
		"name": "Prospector Funds"
	},
	{
		"name": "Provident"
	},
	{
		"name": "Pzena"
	},
	{
		"name": "QRAFT Technologies, Inc"
	},
	{
		"name": "RBC Global Asset Management."
	},
	{
		"name": "REMSGroup"
	},
	{
		"name": "RMB Funds"
	},
	{
		"name": "Range Cancer"
	},
	{
		"name": "Ranger Funds"
	},
	{
		"name": "Rational Funds"
	},
	{
		"name": "Rayliant"
	},
	{
		"name": "Reaves Select Research"
	},
	{
		"name": "Redwheel"
	},
	{
		"name": "Redwheel Asset Management LLP"
	},
	{
		"name": "Redwood Investment Management, LLC"
	},
	{
		"name": "Reflection Asset Management"
	},
	{
		"name": "Reinhartfunds"
	},
	{
		"name": "Renaissance Capital"
	},
	{
		"name": "Research Affiliates LLC"
	},
	{
		"name": "Reverb ETF"
	},
	{
		"name": "ReyndersMcVeigh Funds"
	},
	{
		"name": "Reynolds"
	},
	{
		"name": "Rice Hall James"
	},
	{
		"name": "Rita ETF"
	},
	{
		"name": "River1 Asset Management LLC"
	},
	{
		"name": "RiverPark Funds"
	},
	{
		"name": "Riverbridge"
	},
	{
		"name": "Robo Global"
	},
	{
		"name": "Rockefeller"
	},
	{
		"name": "Rockefeller Asset Management"
	},
	{
		"name": "Roundhill Investments"
	},
	{
		"name": "Royce Investment Partners"
	},
	{
		"name": "Rrecurrent Advisors"
	},
	{
		"name": "Running Oak Capital LLC"
	},
	{
		"name": "Russell"
	},
	{
		"name": "Rydex Funds"
	},
	{
		"name": "SA Funds"
	},
	{
		"name": "SABA ETF"
	},
	{
		"name": "SEI"
	},
	{
		"name": "SP Funds"
	},
	{
		"name": "SRN Advisors"
	},
	{
		"name": "SSGA"
	},
	{
		"name": "STFM"
	},
	{
		"name": "SWP Investment Management, LLC"
	},
	{
		"name": "Sands Capital"
	},
	{
		"name": "Saratoga"
	},
	{
		"name": "Sarmaya Partners, LLC"
	},
	{
		"name": "Sarofim"
	},
	{
		"name": "Saturna Capital"
	},
	{
		"name": "Scharf Investments"
	},
	{
		"name": "Schwab Funds"
	},
	{
		"name": "Schwartz"
	},
	{
		"name": "Seafarer Funds"
	},
	{
		"name": "Segall Bryant & Hamill"
	},
	{
		"name": "Select Funds"
	},
	{
		"name": "Selected Funds"
	},
	{
		"name": "Sequoia"
	},
	{
		"name": "Sextant Mutual Funds"
	},
	{
		"name": "Shelton Capital Management"
	},
	{
		"name": "Simplify Asset Management"
	},
	{
		"name": "Sit"
	},
	{
		"name": "Six Circles"
	},
	{
		"name": "Slow Capital Funds"
	},
	{
		"name": "SmartETFs"
	},
	{
		"name": "Smead Funds"
	},
	{
		"name": "SoFi"
	},
	{
		"name": "SonicShares"
	},
	{
		"name": "Sound ETF"
	},
	{
		"name": "Sound Shore"
	},
	{
		"name": "SouthernSun Asset Management"
	},
	{
		"name": "Sovereign's Capital, LLC"
	},
	{
		"name": "Sparkline Capital"
	},
	{
		"name": "Sparrow"
	},
	{
		"name": "Spear"
	},
	{
		"name": "Spirit of America"
	},
	{
		"name": "Split Rock Private Trading & Wealth Management, LLC"
	},
	{
		"name": "Sprott"
	},
	{
		"name": "Sprucegrove Investment Management Ltd"
	},
	{
		"name": "Spyglass Capital Management"
	},
	{
		"name": "Stance Funds"
	},
	{
		"name": "State Farm"
	},
	{
		"name": "State Street"
	},
	{
		"name": "Sterling Capital Funds"
	},
	{
		"name": "StockSnips"
	},
	{
		"name": "Strategas Asset Management, LLC"
	},
	{
		"name": "Strategic Asset Management"
	},
	{
		"name": "Strategy Shares"
	},
	{
		"name": "Strive AM"
	},
	{
		"name": "Subversive Capital"
	},
	{
		"name": "Summit Global Investments"
	},
	{
		"name": "Symmetry Partners"
	},
	{
		"name": "Syntax"
	},
	{
		"name": "T. Rowe Price"
	},
	{
		"name": "TBG ETF"
	},
	{
		"name": "TCW"
	},
	{
		"name": "TCW ETF"
	},
	{
		"name": "TIAA Investments/Nuveen"
	},
	{
		"name": "Tanaka"
	},
	{
		"name": "Taylor Frigon Capital Management"
	},
	{
		"name": "Tema ETFs"
	},
	{
		"name": "Tema Global Limited"
	},
	{
		"name": "Teton Westwood Funds"
	},
	{
		"name": "Teucrium"
	},
	{
		"name": "Texas Capital Funds Trust"
	},
	{
		"name": "The Burney Company"
	},
	{
		"name": "The Future Fund"
	},
	{
		"name": "The Pacific Financial Group"
	},
	{
		"name": "The Rock Creek Group, LP"
	},
	{
		"name": "Themes ETF Trust"
	},
	{
		"name": "Third Avenue"
	},
	{
		"name": "Thompson IM"
	},
	{
		"name": "Thornburg"
	},
	{
		"name": "Thrift Savings Plan"
	},
	{
		"name": "Thrivent Funds"
	},
	{
		"name": "Timothy Plan"
	},
	{
		"name": "Tocqueville"
	},
	{
		"name": "Torray Investment Partners LLC"
	},
	{
		"name": "Tortoise Capital Advisors, LLC"
	},
	{
		"name": "Touchstone"
	},
	{
		"name": "Towle"
	},
	{
		"name": "Transamerica"
	},
	{
		"name": "Tremblant Advisors LP"
	},
	{
		"name": "Tributary Funds"
	},
	{
		"name": "Trillium Mutual Funds"
	},
	{
		"name": "TrueShares"
	},
	{
		"name": "Tuttle Capital Management, LLC"
	},
	{
		"name": "Tweedy, Browne"
	},
	{
		"name": "U.S. Global Investors"
	},
	{
		"name": "UBS"
	},
	{
		"name": "USA Mutuals"
	},
	{
		"name": "USCF Investments"
	},
	{
		"name": "Union Street Partners"
	},
	{
		"name": "Upright Investments Trust"
	},
	{
		"name": "VALIC"
	},
	{
		"name": "VELA Funds"
	},
	{
		"name": "Value Line"
	},
	{
		"name": "VanEck"
	},
	{
		"name": "Vanguard"
	},
	{
		"name": "Vaughan Nelson"
	},
	{
		"name": "Vericimetry Funds"
	},
	{
		"name": "Vert Asset Management"
	},
	{
		"name": "Victory Capital"
	},
	{
		"name": "Vident Financial"
	},
	{
		"name": "Villere"
	},
	{
		"name": "Virtus"
	},
	{
		"name": "VistaShares Advisors LLC"
	},
	{
		"name": "Volumetric"
	},
	{
		"name": "Vontobel"
	},
	{
		"name": "Vontobel Asset Management Inc"
	},
	{
		"name": "Voya"
	},
	{
		"name": "Vulcan Value Partners"
	},
	{
		"name": "WBI Investments"
	},
	{
		"name": "WCM Investment Management"
	},
	{
		"name": "WHITEWOLF"
	},
	{
		"name": "WP Trust"
	},
	{
		"name": "Wahed Invest"
	},
	{
		"name": "Wall Street"
	},
	{
		"name": "Walthausen Funds"
	},
	{
		"name": "Wasatch"
	},
	{
		"name": "Waycross"
	},
	{
		"name": "WealthTrust Asset Management"
	},
	{
		"name": "Weitz"
	},
	{
		"name": "Wellington Shields"
	},
	{
		"name": "WesMark"
	},
	{
		"name": "Westwood"
	},
	{
		"name": "William Blair"
	},
	{
		"name": "Williamsburg Investment Trust"
	},
	{
		"name": "Wilmington Funds"
	},
	{
		"name": "Wilshire Mutual Funds"
	},
	{
		"name": "Wireless"
	},
	{
		"name": "WisdomTree"
	},
	{
		"name": "World Funds Trust"
	},
	{
		"name": "Wrona Investment Management"
	},
	{
		"name": "Xsquare Capital"
	},
	{
		"name": "Xtrackers"
	},
	{
		"name": "YCG FUNDS"
	},
	{
		"name": "Yoke ETF"
	},
	{
		"name": "Yorktown Funds"
	},
	{
		"name": "Zacks Funds"
	},
	{
		"name": "Zevenbergen Capital Investments"
	},
	{
		"name": "abrdn Funds"
	},
	{
		"name": "iM Global Partner Fund Management"
	},
	{
		"name": "iMGP"
	},
	{
		"name": "kovitzetf"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/FundFamilyAll.json
// module id = 921
// module chunks = 0